import http from '../../axios'
import auth from '../../auth'

export default {
  state: {
    currentUser: null,
    currentAccount: null,
    authError: null,
    token: localStorage.getItem('cTok')
  },
  getters: {
    currentUser(state) {
      return state.currentUser
    },
    currentAccount(state) {
      return state.currentAccount
    },
    authError(state) {
      return state.authError
    },
    token(state) {
      return state.token
    }
  },
  mutations: {
    setAccessToken(state, payload) {
      state.token = payload
      localStorage.setItem('cTok', payload)
    },
    loginFailed(state) {
      state.token = null
      state.currentUser = null
      localStorage.removeItem('cTok')
    },
    logout() {
      localStorage.removeItem('cTok')
      localStorage.removeItem('account')
    },
    authError(state, error) {
      state.authError = error
    },
    setUserInfo(state, payload) {
      state.currentUser = {
        ...payload
      }
    },
    setCurrentAccount(state, account) {
      state.currentAccount = account
      localStorage.setItem('account', JSON.stringify(account))
    }
  },
  actions: {
    async login({ commit, dispatch }, payload) {
      commit('setLoading', true)
      commit('authError', null)
      try {
        const response = await auth.post('oauth/token', {
          client_id: process.env.VUE_APP_CLIENT_ID,
          client_secret: process.env.VUE_APP_CLIENT_SECRET,
          grant_type: process.env.VUE_APP_GRANT_TYPE,
          username: {
            name: payload.username,
            ser: process.env.VUE_APP_SERVICEPROVIDER
          },
          password: payload.password
        })
        if (response.status === 200) {
          commit('setAccessToken', response.data.access_token)
          const user = await dispatch('fetchCurrentUser')
          if (!user) commit('loginFailed')
          commit('setLoading', false)
          return true
        }
      } catch (error) {
        commit('authError', error.response.data.message)
        commit('setLoading', false)
        return false
      }
    },
    async fetchCurrentUser({ commit }) {
      try {
        const response = await http.get('api/v1/customers/customer/me')
        if (response.status === 200) {
          commit('setUserInfo', response.data.data)
          return response.data.data
        } else {
          return null
        }
      } catch (error) {
        commit('authError', error.response.data.message)
        commit('setError', error.response.data.message)
      }
    },
    logout({ commit }) {
      commit('logout')
      window.location.reload()
    }
  }
}
